var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"share-links plain"},_vm._l((_vm.services),function(item){return _c('li',{key:['share',item.type].join('-'),class:item.type},[_c('a',{class:'icon-' + item.type,attrs:{"href":_vm.format(item),"title":item.title,"target":"_blank"}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-293489cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = null
// module chunks = 